import React from 'react';
import Icons from '../Icons';

export default function Advantages(props) {
  return (
    <div className="flex lg:flex-row flex-col lg:text-left text-center items-center shadow-card rounded-2xl mb-4 py-7 px-7">
      <Icons src={props.src} alt={props.alt} />
      <div className="ml-6 w-[85%]">
        <p className="lg:text-xl text-lg font-medium text-[#222222] lg:mt-0 mt-6 lg:mb-0 mb-0.5">
          {props.title}
        </p>
        <p className="lg:text-sm text-xs text-[#999999]">{props.desc}</p>
      </div>
    </div>
  );
}
